import { LocalStorageKeys } from './storageUtils';

export function storeLocationList(locationList) {
  localStorage.setItem(LocalStorageKeys.LOCATION_LIST, JSON.stringify(locationList));
}

export function getLocationList() {
  const storedData = localStorage.getItem(LocalStorageKeys.LOCATION_LIST);
  return storedData ? JSON.parse(storedData) : {};
}
